import { cn } from "../../lib/utils"
function Skeleton({
 className,
 ...props
}: React.HTMLAttributes<HTMLDivElement>) {
 return (
 <div
 className={cn(
 " relative overflow-hidden rounded-md bg-muted before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-gray-200 before:via-gray-100 before:to-gray-200",
 className
 )}
 {...props}
 />
 )
}

export { Skeleton }
